import taxCodeService from '../../../services/TaxCodeService';
import { useEffect, useState } from 'react';

export default function useFetchTaxTypeRecords() {
  const [taxTypeLoading, setTaxTypeLoading] = useState(false);
  const [taxTypeError, setTaxTypeError] = useState('');
  const [taxTypeRecords, setTaxTypeRecords] = useState([]);

  useEffect(() => {
    const fetchTaxTypeRecords = async () => {
      try {
        setTaxTypeLoading(true);
        const taxCodeList = await taxCodeService.getTaxCodeFromQBO();

        const taxCodeListOption = taxCodeList.data.data.QueryResponse.TaxCode.map((c) => {
          return { value: c.Name, label: c.Name, id: c.Id };
        });

        setTaxTypeRecords(taxCodeListOption);
      } catch (error) {
        setTaxTypeError(error?.message || 'Could not fetch tax type records from quicbooks');
      } finally {
        setTaxTypeLoading(false);
        setTaxTypeError('');
      }
    };
    fetchTaxTypeRecords();
  }, []);
  return { taxTypeRecords, taxTypeError, taxTypeLoading };
}
